import { Mail, CheckCircle2, ShieldCheck } from "lucide-react";
import useSEO from "@/components/site/useSEO";
import PageHero from "@/components/site/PageHero";
import DemoForm from "@/components/site/DemoForm";
import { Reveal } from "@/components/site/Reveal";

export default function Contact() {
  useSEO(
    "Book a Demo & Contact | AYOBELL Care Management",
    "See AYOBELL in action for your service. Tell us about your organisation and we'll show you how AYOBELL supports your care model, teams and governance. Contact info@ayobell.com."
  );
  return (
    <>
      <PageHero
        eyebrow="Book a Demo"
        title="See AYOBELL in action for your service."
        subtitle="Tell us about your organisation and we'll show you how AYOBELL can support your care model, teams and governance processes."
      />

      <section className="bg-white py-20 sm:py-28 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-[1fr_1.1fr] gap-12 items-start">
          <Reveal>
            <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl text-slate-900">What to expect</h2>
            <div className="mt-6 space-y-4">
              {["A personalised walkthrough of the platform", "Tailored to your service type & size", "Guidance on data migration & onboarding", "Answers to your governance & security questions"].map((t) => (
                <div key={t} className="flex items-center gap-3 text-slate-700">
                  <CheckCircle2 className="w-5 h-5 text-teal-600 shrink-0" /> <span className="text-sm">{t}</span>
                </div>
              ))}
            </div>

            <div className="mt-10 rounded-2xl border border-slate-200 bg-slate-50 p-6">
              <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-teal-50 text-teal-600"><Mail className="w-5 h-5" /></span>
              <h3 className="font-semibold text-slate-900 mt-4">Prefer to email?</h3>
              <p className="text-sm text-slate-600 mt-1">Reach the AYOBELL team directly.</p>
              <a href="mailto:info@ayobell.com" data-testid="contact-email" className="mt-2 inline-flex items-center gap-2 text-lg font-semibold text-teal-700 hover:text-teal-800 transition-colors">
                info@ayobell.com
              </a>
            </div>

            <p className="mt-6 flex items-start gap-2 text-xs text-slate-400 leading-relaxed">
              <ShieldCheck className="w-4 h-4 mt-0.5 text-teal-500 shrink-0" />
              We handle your enquiry in line with our Privacy Policy and will never share your information with third parties.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <DemoForm />
          </Reveal>
        </div>
      </section>
    </>
  );
}
